import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import {
  BLACK_LANGUAGES,
  DEFAULT_LANGUAGE,
  INIT_LANGUAGE,
  WHITE_LANGUAGES,
} from '@/utils/langUtils';
import jsonCN from './langs/cn.json';
import jsonDE from './langs/de.json';
import jsonEN from './langs/en.json';
import jsonJP from './langs/ja.json';
import jsonKO from './langs/ko.json';

const resources = {
  [WHITE_LANGUAGES[0]]: { translation: jsonKO },
  [WHITE_LANGUAGES[1]]: { translation: jsonEN },
  [BLACK_LANGUAGES[0]]: { translation: jsonJP },
  [BLACK_LANGUAGES[1]]: { translation: jsonCN },
  [BLACK_LANGUAGES[2]]: { translation: jsonDE },
};

i18n.use(initReactI18next).init({
  resources,
  lng: INIT_LANGUAGE,
  fallbackLng: DEFAULT_LANGUAGE,
  whitelist: WHITE_LANGUAGES,
  debug: false,
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ['path', 'navigator'],
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
